import React from "react";
import { AiOutlineClose } from "react-icons/ai";

// TODO Regroup the displaying logic here and use react portals to display it where needed

const InfoPopup = ({
  activeTab,
  togglePopup,
}: {
  activeTab: string;
  togglePopup: () => void;
}) => {
  const generatePopupContent = () => {
    switch (activeTab) {
      case "CO2": {
        return (
          <>
            <div className="titre">Empreinte carbone relative</div>
            <div className="cors">
              <p>
                {" "}
                L’empreinte carbone relative{" "}
                <span className="green">ici -55 kgCO2/h</span> est l’écart de
                consommation de CO2 de l’engin sélectionné par rapport à la
                consommation moyenne d’un groupe d’engins de même type depuis le
                début de la période retenue (jour, semaine, mois, année).
              </p>

              <p>
                Sur cet écran, la mention indique que{" "}
                <span className="green">
                  l’engin sélectionné rejette une quantité de CO2 inférieur de
                  55kg à la moyenne des autres engins du même type.
                </span>
              </p>

              <p>
                Ces informations permettent de se rendre compte de l’empreinte
                carbone relative de la machisne utilisée en fonction de son
                historique d’utilisation.
              </p>
            </div>
          </>
        );
      }
      case "consommation": {
        return (
          <>
            <div className="titre">Consommation de carburant</div>
            <div className="cors">
              <p>
                <strong>Débit moyen : </strong>
                <span className="green">ici 15,5 l/h</span>
                Il s’agit du débit moyen de carburant calculé sur la dernière
                sous période correspondant au créneau temporel retenu, journée,
                semaine entamée, mois ou année en cours.
              </p>
              <table>
                <thead>
                  <tr>
                    <th>Période (1)</th>
                    <th>Sous période (2)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Jour</td>
                    <td>12 dernières heures</td>
                  </tr>
                  <tr>
                    <td>Semaine</td>
                    <td>7 derniers jours</td>
                  </tr>
                  <tr>
                    <td>Mois</td>
                    <td>12 dernières semaines</td>
                  </tr>
                  <tr>
                    <td>Année</td>
                    <td>12 derniers mois</td>
                  </tr>
                </tbody>
              </table>
              <p>
                <strong>
                  Poids équivalent de CO2 rejeté en une heure (en kg CO2/h) :
                </strong>
                <span className="green"> ici 45 kg CO2/h</span>
                Le poids de CO2 équivalent est calculé en multipliant le débit
                moyen par le poids en CO2 équivalent d’un litre du carburant
                indiqué
              </p>

              <table>
                <thead>
                  <tr>
                    <th>Carburant</th>
                    <th>Poids CO2 équivalent</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Essence</td>
                    <td>2.29 kg CO2/l</td>
                  </tr>
                  <tr>
                    <td>Essence E10 10% éthanol</td>
                    <td>2.21 kg CO2/l</td>
                  </tr>
                  <tr>
                    <td>Essence E85 85% éthanol</td>
                    <td>1.61 kg CO2/l</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Diesel</strong>
                    </td>
                    <td>
                      <strong>2.66 kg CO2/l</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>Diesel B5 5% biodiésel</td>
                    <td>2.66 kg CO2/l</td>
                  </tr>
                  <tr>
                    <td>Diesel B5 20% biodiésel</td>
                    <td>2.66 kg CO2/l</td>
                  </tr>
                </tbody>
              </table>
              <p>
                <strong>Moyenne du débit correspondant</strong>
                La valeur du débit moyen représentée est calculé à partir de la
                médiane des débits de carburant d’un groupe d’engins de même
                type, sur une période de référence. Cette période de référence
                correspond aux 30 derniers jours de fonctionnement de chaque
                engin du même type.
              </p>
            </div>
          </>
        );
      }
      case "objectif": {
        return (
          <>
            <div className="titre">Budget CO2</div>
            <div className="cors">
              <p>
                Le budget CO2 de l’engin (en kg CO2) sur une période
                sélectionnée (jour, semaine, mois, année) est calculé par
                extrapolation de la moyenne de consommation d’un ensemble
                d’engins de même type sur une période de référence.
              </p>
              <p>
                Cette période de référence correspond aux 30 derniers jours de
                fonctionnement de chaque engin du même type. Le pourcentage de
                remplissage de la feuille permet de représenter la quantité de
                CO2 consommée par rapport au budget CO2 prévu pour la période
                retenue.{" "}
                <span className="green">
                  Ici, le budget est entièrement disponible car la valeur
                  consommée est de 0kg.
                </span>
              </p>
              <p>
                Note: lors du dépassement du budget la quantité de CO2 consommée
                apparaît <span className="red">en rouge</span>.
              </p>
            </div>
          </>
        );
      }
      case "conseil": {
        return (
          <>
            <div className="titre">Conseils</div>
            <div className="cors">
              <p>
                Cet écran permet de visualiser la performance carbone de l’engin
                sélectionné sur la période retenue (jour, semaine, mois, année)
                selon ses phases de fonctionnement : pendant ses périodes au
                ralenti ou lorsqu’il travaille :
              </p>
              <p>
                <strong>Fonctionnement</strong> indique comment se place
                l’engin, lorsqu’il travaille, par rapport au maximum et au
                minimum de consommation du groupe d’engins de même type sur la
                période de référence.
              </p>
              <p>
                <strong>Ralenti</strong> indique comment se situe la
                consommation de l’engin, au ralenti, par rapport au maximum et
                au minimum de consommation au ralenti du groupe d’engins de même
                type sur la période de référence.
              </p>
              <p>
                Au-dessous du positionnement de l’empreinte relative au ralenti
                est affiché{" "}
                <span className="green">
                  le temps cumulé de ralenti sur le temps pendant lequel le
                  contact est allumé.
                </span>
              </p>
              <p>
                Des conseils spécifiques pour les différents niveaux
                d’empreintes relatives sont affichés pour délivrer les conseils
                d’écoconduite les plus pertinents.
              </p>
            </div>
          </>
        );
      }
    }
  };

  return (
    <div className="popup-info" aria-label="popup-info">
      {generatePopupContent()}
      <button
        onClick={togglePopup}
        className="btClose"
        aria-label={"close-popup"}
      >
        <AiOutlineClose className={"close-iconPopup"} />
      </button>
    </div>
  );
};

export default InfoPopup;
